import { requestMaster } from './request'

/**
 * Elasticsearch 查询函数
 * @param index ES索引名称
 * @param body ES查询body
 */
export const esQuery = async (index: string, body: any) => {
  try {
    const resp = await requestMaster('/common/apis/v1/es_data', {
      body,
      index,
    })

    return resp
  } catch (error) {
    console.error('ES查询失败:', error)
    throw error
  }
}

export default esQuery
